"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReportWebVitals = void 0;
const react_1 = require("react");
const attribution_1 = require("web-vitals/attribution");
function useReportWebVitals(reportWebVitalsFn) {
    (0, react_1.useEffect)(() => {
        (0, attribution_1.onCLS)(reportWebVitalsFn);
        (0, attribution_1.onFID)(reportWebVitalsFn);
        (0, attribution_1.onLCP)(reportWebVitalsFn);
        (0, attribution_1.onINP)(reportWebVitalsFn);
        (0, attribution_1.onFCP)(reportWebVitalsFn);
        (0, attribution_1.onTTFB)(reportWebVitalsFn);
    }, [reportWebVitalsFn]);
}
exports.useReportWebVitals = useReportWebVitals;
